//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import { faXmark } from '@fortawesome/pro-regular-svg-icons';

export default {
  name: 'BeforeLeaveModal',
  data() {
    return {
      faXmark,
    };
  },
  computed: {
    ...mapState({
      leaveTo: state => state.leave.leaveTo,
      showLeaveMessage: state => state.leave.showLeaveMessage,
    }),
  },
  methods: {
    leavePage() {
      this.$store.dispatch('leave/setIsProgress', false);
      this.$router.push(this.leaveTo);
      this.$bvModal.hide('before-leave-modal');
    },
    toggleShowLeaveMessage(event) {
      this.$store.dispatch('leave/setShowLeaveMessage', !event.target.value);
    },
  },
};
